export default __webpack_public_path__ + "static/media/gauge.4392cf3b.svg";